import MatchHeight from 'vanilla-js-match-height'

export default function Heights() {

	new MatchHeight('.js-product-name')
	new MatchHeight('.js-product-price')
	new MatchHeight('.js-product-card')

	new MatchHeight('.js-post-heading')
	new MatchHeight('.js-post-excerpt')

	new MatchHeight('.js-banner-heading')
	new MatchHeight('.js-banner-content')

	new MatchHeight('.js-card-title')
	new MatchHeight('.js-card-content')

	new MatchHeight('.js-case-study', {
		timeOut: 500
	})

	new MatchHeight('.js-case-study-title', {
		timeOut: 300
	})

	new MatchHeight('.js-case-study-content', {
		timeOut: 300
	})

	new MatchHeight('.js-case-study-stats', {
		timeOut: 300
	});

	new MatchHeight('.js-product-title', {
		byRow: false
	});

	new MatchHeight('.js-product-description', {
		byRow: false
	});

	new MatchHeight('.js-search-title')

}
